(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function normalise(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function initResourceDirectories() {
    document
      .querySelectorAll('[data-resource-directory]')
      .forEach(function (directory) {
        var filters = Array.prototype.slice.call(
          directory.querySelectorAll('[data-resource-filter]')
        );

        var cards = Array.prototype.slice.call(
          directory.querySelectorAll('[data-resource-card]')
        );

        var search = directory.querySelector('[data-resource-search]');
        var status = directory.querySelector('[data-resource-status]');
        var empty = directory.querySelector('[data-resource-empty]');
        var activeFilter = 'all';

        if (!cards.length) return;

        function updateDirectory() {
          var searchTerm = search ? normalise(search.value) : '';
          var visibleCount = 0;

          cards.forEach(function (card) {
            var categories = normalise(
              card.getAttribute('data-resource-category')
            ).split(/\s+/);

            var searchableText = normalise(
              card.getAttribute('data-resource-keywords') ||
                card.textContent
            );

            var matchesFilter =
              activeFilter === 'all' ||
              categories.indexOf(activeFilter) !== -1;

            var matchesSearch =
              !searchTerm ||
              searchableText.indexOf(searchTerm) !== -1;

            var isVisible = matchesFilter && matchesSearch;

            card.classList.toggle('is-hidden', !isVisible);

            card.setAttribute(
              'aria-hidden',
              isVisible ? 'false' : 'true'
            );

            if (isVisible) {
              visibleCount += 1;
            }
          });

          if (status) {
            status.textContent =
              visibleCount === 1
                ? '1 resource shown'
                : visibleCount + ' resources shown';
          }

          if (empty) {
            empty.hidden = visibleCount !== 0;
          }
        }

        filters.forEach(function (button) {
          button.addEventListener('click', function () {
            activeFilter =
              normalise(
                button.getAttribute('data-resource-filter')
              ) || 'all';

            filters.forEach(function (item) {
              var isActive = item === button;

              item.classList.toggle('is-active', isActive);

              item.setAttribute(
                'aria-pressed',
                isActive ? 'true' : 'false'
              );
            });

            updateDirectory();
          });
        });

        if (search) {
          search.addEventListener('input', updateDirectory);
        }

        updateDirectory();
      });
  }

  function initAccordions() {
    document
      .querySelectorAll('[data-resource-accordion]')
      .forEach(function (accordion, index) {
        var button = accordion.querySelector(
          '[data-resource-accordion-button]'
        );

        var panel = accordion.querySelector(
          '[data-resource-accordion-panel]'
        );

        if (!button || !panel) return;

        if (!panel.id) {
          panel.id = 'ResourceAccordionPanel-' + index;
        }

        button.setAttribute('aria-controls', panel.id);

        function setOpen(isOpen) {
          accordion.classList.toggle('is-open', isOpen);

          button.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
          );

          panel.hidden = !isOpen;
        }

        setOpen(button.getAttribute('aria-expanded') === 'true');

        button.addEventListener('click', function () {
          setOpen(
            button.getAttribute('aria-expanded') !== 'true'
          );
        });
      });
  }

  function slugifyHeading(value) {
    return normalise(value)
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueId(base, usedIds) {
    var root = base || 'section';
    var candidate = root;
    var count = 2;

    while (
      usedIds[candidate] ||
      document.getElementById(candidate)
    ) {
      candidate = root + '-' + count;
      count += 1;
    }

    usedIds[candidate] = true;

    return candidate;
  }

  function initTablesOfContents() {
    document
      .querySelectorAll('[data-resource-article]')
      .forEach(function (article) {
        var content = article.querySelector(
          '[data-resource-content]'
        );

        var toc = article.querySelector(
          '[data-resource-toc]'
        );

        var tocWrap = article.querySelector(
          '[data-resource-toc-wrap]'
        );

        if (!content || !toc) return;

        var headings = Array.prototype.slice.call(
          content.querySelectorAll('h2')
        );

        if (!headings.length) {
          if (tocWrap) {
            tocWrap.hidden = true;
          }

          return;
        }

        var usedIds = {};
        var links = [];

        headings.forEach(function (heading) {
          var id =
            heading.id ||
            uniqueId(
              slugifyHeading(heading.textContent),
              usedIds
            );

          heading.id = id;

          var link = document.createElement('a');

          link.href = '#' + id;
          link.textContent = heading.textContent;

          toc.appendChild(link);
          links.push(link);
        });

        if (tocWrap) {
          tocWrap.hidden = false;
        }

        function setActiveLink() {
          var activeIndex = 0;
          var marker = window.scrollY + 160;

          headings.forEach(function (heading, index) {
            if (heading.offsetTop <= marker) {
              activeIndex = index;
            }
          });

          links.forEach(function (link, index) {
            link.classList.toggle(
              'is-active',
              index === activeIndex
            );
          });
        }

        setActiveLink();

        window.addEventListener(
          'scroll',
          setActiveLink,
          { passive: true }
        );
      });
  }

  function initLightboxes() {
    document
      .querySelectorAll('[data-resource-article]')
      .forEach(function (article, articleIndex) {
        var content = article.querySelector(
          '[data-resource-content]'
        );

        if (!content) return;

        var lightbox = article.querySelector(
          '[data-resource-lightbox]'
        );

        if (!lightbox) {
          lightbox = document.createElement('div');

          lightbox.className = 'resource-lightbox';

          lightbox.setAttribute(
            'data-resource-lightbox',
            ''
          );

          lightbox.setAttribute('role', 'dialog');
          lightbox.setAttribute('aria-modal', 'true');

          lightbox.setAttribute(
            'aria-label',
            'Enlarged image'
          );

          lightbox.setAttribute(
            'aria-hidden',
            'true'
          );

          lightbox.innerHTML =
            '<button class="resource-lightbox__close" ' +
            'type="button" aria-label="Close image">' +
            '&times;</button>' +
            '<img class="resource-lightbox__image" alt="">';

          article.appendChild(lightbox);
        }

        var lightboxImage = lightbox.querySelector(
          '.resource-lightbox__image'
        );

        var closeButton = lightbox.querySelector(
          '.resource-lightbox__close'
        );

        var lastTrigger = null;

        function openLightbox(image) {
          lastTrigger = image;

          lightboxImage.src =
            image.currentSrc || image.src;

          lightboxImage.alt = image.alt || '';

          lightbox.classList.add('is-open');

          lightbox.setAttribute(
            'aria-hidden',
            'false'
          );

          document.body.classList.add(
            'resource-lightbox-open'
          );

          closeButton.focus();
        }

        function closeLightbox() {
          lightbox.classList.remove('is-open');

          lightbox.setAttribute(
            'aria-hidden',
            'true'
          );

          document.body.classList.remove(
            'resource-lightbox-open'
          );

          lightboxImage.removeAttribute('src');

          if (lastTrigger) {
            lastTrigger.focus();
          }
        }

        content
          .querySelectorAll('img')
          .forEach(function (image, imageIndex) {
            image.tabIndex = 0;
            image.setAttribute('role', 'button');

            image.setAttribute(
              'aria-label',
              (image.alt || 'Guide image') +
                ' — enlarge image'
            );

            image.setAttribute(
              'data-resource-image',
              articleIndex + '-' + imageIndex
            );

            image.addEventListener(
              'click',
              function () {
                openLightbox(image);
              }
            );

            image.addEventListener(
              'keydown',
              function (event) {
                if (
                  event.key === 'Enter' ||
                  event.key === ' '
                ) {
                  event.preventDefault();
                  openLightbox(image);
                }
              }
            );
          });

        closeButton.addEventListener(
          'click',
          closeLightbox
        );

        lightbox.addEventListener(
          'click',
          function (event) {
            if (event.target === lightbox) {
              closeLightbox();
            }
          }
        );

        document.addEventListener(
          'keydown',
          function (event) {
            if (
              event.key === 'Escape' &&
              lightbox.classList.contains('is-open')
            ) {
              closeLightbox();
            }
          }
        );
      });
  }

  function initSliders() {
    document
      .querySelectorAll('[data-resource-slider]')
      .forEach(function (slider) {
        var track = slider.querySelector(
          '[data-resource-slider-track]'
        );

        var slides = track
          ? Array.prototype.slice.call(
              track.querySelectorAll('[data-resource-slide]')
            )
          : [];

        var previous = slider.querySelector(
          '[data-resource-slider-prev]'
        );

        var next = slider.querySelector(
          '[data-resource-slider-next]'
        );

        var dots = slider.querySelector(
          '[data-resource-slider-dots]'
        );

        var counter = slider.querySelector(
          '[data-resource-slider-counter]'
        );

        var viewport = slider.querySelector(
          '.resource-slider__viewport'
        );

        var current = 0;
        var startX = null;

        if (!track || !slides.length) return;

        function goTo(index) {
          current =
            (index + slides.length) %
            slides.length;

          track.style.transform =
            'translateX(-' +
            current * 100 +
            '%)';

          slides.forEach(
            function (slide, slideIndex) {
              slide.setAttribute(
                'aria-hidden',
                slideIndex === current
                  ? 'false'
                  : 'true'
              );
            }
          );

          if (dots) {
            dots
              .querySelectorAll(
                '.resource-slider__dot'
              )
              .forEach(
                function (dot, dotIndex) {
                  var isActive =
                    dotIndex === current;

                  dot.classList.toggle(
                    'is-active',
                    isActive
                  );

                  dot.setAttribute(
                    'aria-current',
                    isActive
                      ? 'true'
                      : 'false'
                  );
                }
              );
          }

          if (counter) {
            counter.textContent =
              current + 1 +
              ' / ' +
              slides.length;
          }
        }

        if (dots && !dots.children.length) {
          slides.forEach(function (_, index) {
            var dot =
              document.createElement('button');

            dot.type = 'button';
            dot.className =
              'resource-slider__dot';

            dot.setAttribute(
              'aria-label',
              'Go to slide ' + (index + 1)
            );

            dot.addEventListener(
              'click',
              function () {
                goTo(index);
              }
            );

            dots.appendChild(dot);
          });
        }

        if (previous) {
          previous.addEventListener(
            'click',
            function () {
              goTo(current - 1);
            }
          );
        }

        if (next) {
          next.addEventListener(
            'click',
            function () {
              goTo(current + 1);
            }
          );
        }

        if (viewport) {
          viewport.addEventListener(
            'touchstart',
            function (event) {
              startX =
                event.touches[0].clientX;
            },
            { passive: true }
          );

          viewport.addEventListener(
            'touchend',
            function (event) {
              if (startX === null) return;

              var difference =
                event.changedTouches[0].clientX -
                startX;

              if (Math.abs(difference) > 45) {
                goTo(
                  current +
                    (difference < 0 ? 1 : -1)
                );
              }

              startX = null;
            },
            { passive: true }
          );
        }

        goTo(0);
      });
  }

  ready(function () {
    initResourceDirectories();
    initAccordions();
    initTablesOfContents();
    initLightboxes();
    initSliders();
  });
})();